import { type HTMLAttributes, type JSX } from 'react';

export interface BoxProps extends
  Pick<
    HTMLAttributes<HTMLDivElement>,
    'style' | 'className' | 'children'
  >
{
  ml?: number;
  mr?: number;
  mt?: number;
  mb?: number;
  mx?: number;
  my?: number;
  m?: number;
  pl?: number;
  pr?: number;
  pt?: number;
  pb?: number;
  px?: number;
  py?: number;
  p?: number;
  tagName?: keyof JSX.IntrinsicElements;
  onClick?: () => void;
}

function Box(
  {
    ml,
    mr,
    mt,
    mb,
    mx,
    my,
    m,
    pl,
    pr,
    pt,
    pb,
    px,
    py,
    p,
    tagName: Tag = 'div',
    style,
    ...rest
  }: Readonly<BoxProps>,
) {
  const boxStyles = {
    marginRight: (m || mr || mx) ? (mr || mx || m)! * 4 : undefined, // NOSONAR:S6606 - Intentional: zero/empty values should trigger fallback
    marginLeft: (m || ml || mx) ? (ml || mx || m)! * 4 : undefined, // NOSONAR:S6606 - Intentional: zero/empty values should trigger fallback
    marginTop: (m || mt || my) ? (mt || my || m)! * 4 : undefined, // NOSONAR:S6606 - Intentional: zero/empty values should trigger fallback
    marginBottom: (m || mb || my) ? (my || mb || m)! * 4 : undefined, // NOSONAR:S6606 - Intentional: zero/empty values should trigger fallback
    paddingRight: (p || pr || px) ? (pr || px || p)! * 4 : undefined, // NOSONAR:S6606 - Intentional: zero/empty values should trigger fallback
    paddingLeft: (p || pl || px) ? (pl || px || p)! * 4 : undefined, // NOSONAR:S6606 - Intentional: zero/empty values should trigger fallback
    paddingTop: (p || pt || py) ? (pt || py || p)! * 4 : undefined, // NOSONAR:S6606 - Intentional: zero/empty values should trigger fallback
    paddingBottom: (p || pb || py) ? (pb || py || p)! * 4 : undefined, // NOSONAR:S6606 - Intentional: zero/empty values should trigger fallback
    ...style,
  };

  return <Tag {...rest} style={boxStyles} />;
}

export default Box;
